import React, {useContext, useEffect, useState} from "react";
import SearchForm from "../Form/SearchForm/SearchForm";
import {useSearchParams} from "react-router-dom";
import {fetchAPI} from "../../helpers/APIHelper";
import Error from "../Error";
import PropertyCard from "./PropertyCard";
import PromotionCard from "../Promotion/PromotionCard";
import Pagination from "../Navigation/Pagination";
import {AppContext, ROOT_DIR} from "../../App";
import {RoutingHelper} from "../Navigation/Routing";
import {Helmet} from "react-helmet";

function PropertySearchList({promotionRef, props}) {
    const [searchParams, setSearchParams] = useSearchParams();

    const {isMobile} = useContext(AppContext);

    const [properties, setProperties] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(0);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    let actionType = searchParams.get("actionType") !== null && searchParams.get("actionType") !== "" ? searchParams.get("actionType") : null;
    let budget = searchParams.get("budget");
    let cities = searchParams.get("cities") !== null && searchParams.get("cities") !== "" ? searchParams.get("cities").split(",") : null;
    let types = searchParams.get("types") !== null && searchParams.get("types") !== "" ? searchParams.get("types").split(",") : null;
    let sold = searchParams.get("sold") !== null && searchParams.get("sold") !== "" ? searchParams.get("sold") : false;
    let minRooms = searchParams.get("minRooms") !== null && searchParams.get("minRooms") !== "" ? searchParams.get("minRooms") : null;
    let currentPage = searchParams.get("page") !== null && searchParams.get("page") !== "" ? searchParams.get("page") : 1;

    if (props) {
        actionType = props?.actionType ?? actionType;
        budget = props?.budget ?? budget;
        cities = props?.cities ?? cities;
        types = props?.types ?? types;
        sold = props?.sold ?? sold;
        minRooms = props?.minRooms ?? minRooms;
        currentPage = RoutingHelper.on("annonces") ? 0 : parseInt(props?.page ?? currentPage);
    }

    const [params, setParams] = useState({
        actionType: actionType,
        budget: budget,
        cities: cities,
        types: types,
        sold: sold,
        minRooms: minRooms,
        page: currentPage,
    });

    useEffect(() => {
        fetchAPI({endpoint: "/properties/search", method: "POST", body: params})
            .then(res => {
                if (res?.properties) {
                    setProperties(res.properties);
                    setTotalItems(res.totalItems);
                    setItemsPerPage(res.itemsPerPage);
                } else {
                    setError(res);
                }
                setLoading(false);
            });

    }, [params]);

    function handlePageChange(newPage) {
        if (newPage > 0 && newPage <= Math.ceil(totalItems / itemsPerPage)) {
            window.scrollTo({top: (isMobile ? 500 : 300), behavior: "smooth"});
            searchParams.set("page", newPage);
            setSearchParams(searchParams)
            updateParam("page", newPage);
        }
    }

    function updateParam(field, value) {
        let tempParams = JSON.parse(JSON.stringify(params));

        tempParams[field] = value;

        setParams(tempParams);
    }

    if (error) {
        return <Error/>;
    }

    return (
        <>
            <Helmet>
                {RoutingHelper.on("annonces") ?
                    <link rel="canonical" href={ROOT_DIR + RoutingHelper.getPath("recherche") + "?page=1"}/> : ""}
            </Helmet>
            <div className="flex justify-center w-full mb-5">
                <div className="w-4/5 z-30">
                    <SearchForm params={params}/>
                </div>
            </div>
            {!loading &&
                <div className="mb-5">
                    <Pagination page={params.page} totalItems={totalItems} itemsPerPage={itemsPerPage}
                                changePage={handlePageChange}/>
                </div>
            }

            <div className="flex justify-between container mx-auto w-10/12 md:w-9/12 text-xs md:text-sm mb-5">
                <p>{totalItems} élément{totalItems > 1 && "s"}</p>
                {!RoutingHelper.on("annonces") &&
                    <a href={RoutingHelper.getPath("annonces")}
                       className="text-primary-light hover:underline font-bold">
                        Voir toutes nos annonces
                    </a>
                }
            </div>

            <section id="liste-de-biens"
                     className="container mx-auto w-10/12 md:w-9/12 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 mb-5 md:mb-10">
                {(!loading || properties.length > 0) &&
                    <>
                        {properties.map((property, index) => {
                            if ("isPromotion" in property && property.isPromotion === true) {
                                return (
                                    <PromotionCard key={index} promotion={property}/>
                                );
                            }

                            return (<PropertyCard
                                key={index}
                                property={property}
                                promotionRef={promotionRef}
                            />);
                        })}
                    </>
                }
            </section>
            {!loading &&
                <Pagination page={params.page} totalItems={totalItems} itemsPerPage={itemsPerPage}
                            changePage={handlePageChange}/>
            }
        </>
    );
}

export default PropertySearchList;